import React from 'react';
import clsx from 'clsx';

import PcBasicTemplate from 'components/templates/PcBasicTemplate';
import PcSuggestList from 'components/molecules/PcSuggestList';
import TextBox from 'components/atoms/Input/TextBox';
import DropdownInput from 'components/atoms/Input/DropdownInput';
import PcInputLine from 'components/molecules/PcInputLine';
import PcErrorArea from 'components/molecules/PcErrorArea';
import PcSuccessArea from 'components/molecules/PcSuccessArea';
import PcModalBack from 'components/molecules/PcModalBack';
import './index.pc.scss';

const PresentPC = ({
  onClickMainButton,
  handleChangeEkiName,
  modalBackIsEnable,
  handleClickEkiSuggest,
  handleChangeMoveTypeCd,
  handleChangeMoveTime,
  handleChangeMoveTimeFromBusStop,
  moveTypeCdList,
  ekiName,
  searchNames,
  moveTypeCd,
  moveTime,
  moveTimeFromBusStop,
  valid,
  errorDispMap,
  successMessage,
  isApiError,
  lpMode,
}) => {
  return (
    <div className="Station">
      <PcBasicTemplate
        path={window.location.pathname}
        onClickMainButton={onClickMainButton} 
        valid={valid}
        isApiError={isApiError}
        lpMode={lpMode}
      >
        <br />
        
        <PcInputLine 
          title="就業先の最寄り駅" 
        >
          <span className="textMiddleHigh">
            <TextBox
              name="ekiName"
              val={ekiName}
              onChange={handleChangeEkiName}
              placeholder="例) 新橋"
              inValid={!!errorDispMap.ekiName || !!errorDispMap.ekiCd}
              maxLength="72"
              suggestText
            />
          </span>

          <PcErrorArea message={errorDispMap.ekiName || errorDispMap.ekiCd} />
          <PcSuccessArea message={successMessage} />
        </PcInputLine>
        {/* 駅サジェストエリア */}
        <div className="searchNamesWrapper">
          <div className="searchNames">
            <PcSuggestList
              items={searchNames.map(x => x.ekiNm)}
              onClick={handleClickEkiSuggest}
            />
          </div>
        </div>

        <PcInputLine title="駅からの所要時間">
          <DropdownInput
            items={moveTypeCdList}
            onChange={handleChangeMoveTypeCd}
            selectedValue={moveTypeCd}
          />
          <span className="textMinutes">
            <TextBox
              name="time"
              val={moveTime}
              onChange={handleChangeMoveTime}
              placeholder="5"
              inValid={!!errorDispMap.moveTime}
              maxLength="3"
            />
            分
          </span>
          <PcErrorArea message={errorDispMap.moveTime} />
        </PcInputLine>

        <div className={clsx(
          'selectedBus',
          { bus: moveTypeCd === '2' },
          { other: moveTypeCd !== '2' },
        )}
        >
          <PcInputLine title="バス停からの所要時間">
            <span className="textMinutesFromBusStop">
              徒歩
              <TextBox
                name="timeFromBusStop"
                val={moveTimeFromBusStop}
                onChange={handleChangeMoveTimeFromBusStop}
                placeholder="5"
                inValid={!!errorDispMap.moveTimeFromBusStop}
                maxLength="3"
              />
              分
            </span>
            <PcErrorArea message={errorDispMap.moveTimeFromBusStop} />
          </PcInputLine>
        </div>
        <PcModalBack
          modalBackIsEnable={modalBackIsEnable}
        />
      </PcBasicTemplate>
    </div>
  );};

export default PresentPC;
